import { render, staticRenderFns } from "./borrow-card.vue?vue&type=template&id=7cc68208&scoped=true"
import script from "./borrow-card.vue?vue&type=script&lang=ts"
export * from "./borrow-card.vue?vue&type=script&lang=ts"
import style0 from "./borrow-card.vue?vue&type=style&index=0&id=7cc68208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc68208",
  null
  
)

export default component.exports